import { Link } from "react-router-dom";
import { Calendar, BookOpen, Package } from "lucide-react";
import { Badge } from "./ui/badge";

const FMT_LABEL = { ebook: "Ebook", physical: "Physical", both: "Ebook + Physical" };

export function CampaignCard({ campaign }) {
  const cover =
    campaign.cover_url ||
    "https://images.unsplash.com/photo-1620233977581-509e4c6b0636?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";
  const deadline = campaign.review_deadline
    ? new Date(campaign.review_deadline).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
    : "TBD";

  return (
    <Link
      to={`/campaigns/${campaign.id}`}
      data-testid={`campaign-card-${campaign.id}`}
      className="paper-card overflow-hidden group flex flex-col hover:-translate-y-0.5 hover:shadow-md"
      style={{ transition: "transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease" }}
    >
      <div className="aspect-[3/4] overflow-hidden bg-slate-100">
        <img
          src={cover}
          alt={campaign.title}
          className="h-full w-full object-cover group-hover:scale-[1.02]"
          style={{ transition: "transform 400ms ease" }}
        />
      </div>
      <div className="p-4 flex-1 flex flex-col gap-2">
        <div className="overline">{campaign.genre}</div>
        <h3 className="font-serif text-xl leading-tight" style={{ color: "var(--ink)" }}>
          {campaign.title}
        </h3>
        <p className="text-sm text-slate-600">by {campaign.pen_name}</p>

        <div className="flex flex-wrap gap-2 mt-2">
          <Badge variant="outline" className="border-amber-200 bg-amber-50 text-amber-800">
            <BookOpen size={12} className="mr-1" /> {FMT_LABEL[campaign.arc_format]}
          </Badge>
          <Badge variant="outline" className="border-slate-200 bg-slate-50 text-slate-700">
            <Package size={12} className="mr-1" /> {campaign.copies_available} copies
          </Badge>
          {campaign.author_auto_accept_enabled && (
            <Badge className="status-auto border">Auto-Accept</Badge>
          )}
        </div>

        <div className="flex items-center justify-between pt-3 mt-auto border-t" style={{ borderColor: "var(--border-soft)" }}>
          <span className="text-xs font-mono text-slate-500 flex items-center gap-1">
            <Calendar size={12} /> {deadline}
          </span>
          <span className="text-xs text-slate-500">{campaign.applications_count} applied</span>
        </div>
      </div>
    </Link>
  );
}
